import { ReactElement } from 'react';
import PlaceIcon from '@mui/icons-material/Place';
import LanguageIcon from '@mui/icons-material/Language';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';

export type ContactLink = {
  href: string;
  icon: ReactElement;
  text: string;
  divider: boolean;
  data_qa_element_id: string;
};

export const links: ContactLink[] = [
  {
    href: 'https://www.google.com/maps/search/?api=1&query=iData+Kft.,Budapest',
    icon: <PlaceIcon className="contacts-icon" />,
    text: 'H-1103 Budapest, Gergely utca 112/C.',
    divider: false,
    data_qa_element_id: 'contacts-address',
  },
  {
    href: 'https://itrack.hu',
    icon: <LanguageIcon className="contacts-icon" />,
    text: 'itrack.hu',
    divider: false,
    data_qa_element_id: 'contacts-itrack',
  },
  {
    href: 'https://help.itrack.hu',
    icon: <img src="svg/itrack_small.svg" alt="iTrack logo" className="contacts-small-logo" />,
    text: 'help.itrack.hu',
    divider: true,
    data_qa_element_id: 'contacts-help-itrack',
  },
  {
    href: 'tel:+3617767676',
    icon: <LocalPhoneIcon className="contacts-icon" />,
    text: '+36-1-776-7676',
    divider: false,
    data_qa_element_id: 'contacts-phone',
  },
  {
    href: 'mailto:info@idata.hu',
    icon: <MailOutlineIcon className="contacts-icon" />,
    text: 'info@idata.hu',
    divider: true,
    data_qa_element_id: 'contacts-email',
  },
  {
    href: 'https://facebook.com/jarmukovetes/',
    icon: <FacebookIcon className="contacts-icon" />,
    text: 'facebook.com/jarmukovetes',
    divider: false,
    data_qa_element_id: 'contacts-facebook',
  },
  {
    href: 'https://linkedin.com/company/idata-kft/',
    icon: <LinkedInIcon className="contacts-icon" />,
    text: 'linkedin.com/company/idata-kft',
    divider: false,
    data_qa_element_id: 'contacts-linkedin',
  },
  {
    href: 'https://instagram.com/idata.insta',
    icon: <InstagramIcon className="contacts-icon" />,
    text: 'instagram.com/idata.insta',
    divider: false,
    data_qa_element_id: 'contacts-instagram',
  },
  {
    href: 'https://youtube.com/iTrackHU',
    icon: <YouTubeIcon className="contacts-icon" />,
    text: 'youtube.com/iTrackHU',
    divider: false,
    data_qa_element_id: 'contacts-youtube',
  },
];
